module.exports = "/_next/static/images/ourPartnersClearwaveLogo-35d985d518e8b79aefaeef0bbc6ac978.webp";